import * as React from 'react';
import { Dispatch } from 'redux';
import { EventVideoViewModel, UploadedVideoViewModel } from 'stageclip-common';

import { BaseApiPostRequest } from '../generic/baseApiPostRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import * as EventVideoNormalizers from '../normalizers/eventVideoNormalizers';

export class AddEventVideoRequest extends BaseApiPostRequest<
  EventVideoViewModel,
  EntityNormalizers.NormalizedSingleEntity<EventVideoNormalizers.NormalizedEventVideos>
> {
  constructor(eventId: string, formData: UploadedVideoViewModel, component: React.Component, dispatch: Dispatch) {
    super(formData, component, dispatch);
    this.path = `/events/${eventId}/event-videos`;
    this.normalizeMethod = EventVideoNormalizers.normalizeEventVideo;
  }
}
